 

 
const routesList = [
    { path: '/', redirect: '/home' }
]

export default routesList
